export const addRoleDialogTranslations = {
    en: {
        role: "Role",
        roleRequired: "Please enter role",
        selectUserType: "Select User Type",
        roleTypeRequired: "Please Select Role Type",
        submit: "Submit",
        createSuccess: "Role created successfully",
        updateSuccess: "Role details updated successfully",
        submitError: "An error occurred while processing the request.",
        unexpectedError: "Something went wrong. Please try again later."
    },
    mr: {
        role: "भूमिका",
        roleRequired: "कृपया भूमिका प्रविष्ट करा",
        selectUserType: "वापरकर्ता प्रकार निवडा",
        roleTypeRequired: "कृपया भूमिका प्रकार निवडा",
        submit: "सबमिट करा",
        createSuccess: "भूमिका यशस्वीरित्या तयार केली",
        updateSuccess: "भूमिका तपशील यशस्वीरित्या अपडेट केले",
        submitError: "विनंती प्रक्रिया करताना त्रुटी आली.",
        unexpectedError: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा."
    }
};
